import styled from 'styled-components';
import { PopoverContent } from 'ui/popover';
import { zIndex, colors, spacing, subtitle1 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledSectionHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledSectionHeadingTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  padding-bottom: ${spacing.base};
`;

export const StyledPopoverContent = styled(PopoverContent)`
  z-index: ${zIndex.modalOverlay + 1};
  width: ${pxToRem(250)};
`;

export const StyledSubtitle1 = styled.div`
  ${subtitle1};
  margin: 0;
`;

export const StyledFocusedHelp = styled.div`
  border: ${spacing.single} solid ${colors.purple50};
  border-radius: 50%;
  display: inline-flex;
`;
